import { useIntl } from 'react-intl'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import TextLink from 'LuxKit/TextLink'

interface Props {
  expanded: boolean
  remainingCount: number
  listId: string
  onToggle: () => void
}

function AccommodationPackageInclusionsToggle({ expanded, remainingCount, listId, onToggle }: Props) {
  const intl = useIntl()
  if (!remainingCount) return null
  return <TextLink size="small" weight="bold" underline={false} onClick={onToggle} aria-controls={listId} aria-expanded={expanded} endIcon={<DropdownChevron open={expanded} />}>
    {expanded ? intl.formatMessage({
      id: 'wWVMcmB1ErAAoIFYh_2_',
      defaultMessage: 'Show less',
      description: 'Collapses the package inclusion list to its initially visible benefits on the hotel offer page',
    }) : intl.formatMessage({
      id: 'iFZOHoSiRaE5ZRAEgPzV',
      defaultMessage: 'Show {count} more',
      description: 'Expands the hotel package inclusion list and shows the number of benefits that remain hidden',
    }, { count: remainingCount })}
  </TextLink>
}

export default AccommodationPackageInclusionsToggle
